import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { audiosAssets } from '../../assets/audio';
import { ButtonPlay } from '../../components/common/ButtonPlay';
import { ButtonHome } from '../../components/common/ButtonHome';
import { SelectorCharacterUI } from '../introduction/SelectorCharacterUI';
import { DialogBarNew } from '../../components/common/DialogBarNew';
import { HeaderRedPresentation } from '../../components/common/HeaderRedPresentation';
import { voicesTypeControl } from "../../types/audioType";
import { ButtonReturn } from '../../components/common/ButtonReturn';


const steps = {
	selectCharacter: 1,
	dialogInitial: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
};

const stepThree = {
	move_monitor: {
		ui: steps.dialogSix,
		action: () => {

		}
	},
}

export const Theme6Introduction = () => {
	const { loaded } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 intro");
			ObserverEmitter.emit(EVENTS.tema6.introduction, 0);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int01)
	})

	ObserverEmitter.on(EVENTS.tema6.intro.listenMonitor, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.intro.monitorActivi, "reboot")
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int01)
						setUiToShow(2)
					}} />
				)}
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int01)
						setUiToShow(steps.dialogInitial);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogInitial && (
				<DialogBarNew
					dialog={
						`¡Muy bien! Ahora veamos nuestro tema número 6: "Servicios Electrónicos"`
					}
					percentage={"50%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int02)
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						setUiToShow(steps.dialogTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						`El objetivo de nuestro tema es: Conocer las actividades dentro de los “Servicios Electrónicos”, las cuales son aplicadas en tu día a día.`
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int03)
						setUiToShow(steps.dialogThree)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={
						`Al realizar las actividades y misiones que se presentan durante el recorrido obtendrás puntos que miden tu aprendizaje.`
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int04)
						setUiToShow(steps.dialogFour)
					}}
				></DialogBarNew>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<HeaderRedPresentation name="introducción" />
					<DialogBarNew
						dialog={
							`Después de nuestro tema de Servicios Financieros, procederemos con nuestro tema de Servicios Electrónicos.`
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int05)
							setUiToShow(steps.dialogFive)
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={
							`¡Veamos cómo se realizan tus actividades y sumemos puntos para completar tu capacitación!`
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.intro.monitorActivi, "move_monitor")
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int06)
							setUiToShow(-1)
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={
							`El menú que se te presenta en pantalla es dónde encontraremos las opciones de servicios con las que contamos.`
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.intro.monitorActivi, "monitor_two_texture")
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.introduccion.int07)
							setUiToShow(steps.dialogSeven)
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={
							`El menú que se te presenta en pantalla es dónde encontraremos las opciones para hacer los pagos de servicio que te pidan.`
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							window.location.href = "/home6/tema6/subtema1/activityOne"
						}}
					></DialogBarNew>
				</>
			)}

		</>
	)
}
